import request from "@utils/request";



const SearchApiService = {
    /**
     * 查询
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#7901
     *

     * @param callback
     * @returns {Function}
     */
    fetch(data={}) {
        return request({
            url:  "/service/mg/home/base/search",
            method: "POST",
            data
        });
    }
};

export default SearchApiService;
